export default __webpack_public_path__ + "media/components/AvailabilityChecker/images/loading-60ad8f1275594db49eb2510af1a66e1d.png";